<template>
  <div class="cookie-container">
    <div class="wrapper py-4 px-3 size-12">
      <div class="weight5">Wir nutzen Cookies!</div>
      <div class="light-text">
        Wir verwenden Cookies, um Dein Benutzererlebnis zu verbessern und zur Analyse der Seitennutzung.
        Weitere Details erfahrt Ihr in unserer Datenschutzrichtlinie:
        <u
          style="white-space: pre"
          @click="$router.push('/data')"
          class="white--text pointer"
        >Cookie Policy</u>
      </div>
      <v-btn @click="$emit('cookieAction')" class="mt-3 width-100" small color="grey lighten-2">
        <v-icon class="mr-2">mdi-check</v-icon>OK
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cookie-dialog'
}
</script>

<style lang="scss" scoped>
.cookie-container {
  width: 100%;
  z-index: 99999;

  .wrapper {
    position: absolute;
    bottom: 0;
    background-color: rgb(72,72,72);
    color: white;
  }

  .light-text {
    color: rgb(218, 218, 218);
  }
}
@media only screen and (min-width: 500px) {
  .cookie-container {
    position: sticky;
    top: 0;
    left: 0;
    margin-top: -10000%;
    height: 100%;
    pointer-events: none;

    .wrapper {
      pointer-events: all;
      bottom: -1px;
    }
  }
}
@media only screen and (max-width: 499px) {
  .cookie-container {
    position: fixed;
    bottom: 0;
  }
}
</style>